import { Message } from '../message.model';

export interface BodyDailyFlow {
  Tipo_consulta_BD: "RANGO_DIAS";
  fecha_inicial: string;
  fecha_final: string;
  sector: string;
  sucursal: string;
  fecha_periodo_anterior?: {
    fecha_inicial: string;
    fecha_final: string;
  };
}

export interface ResponseDailyFlow {
  column_name: ColumnNameDailyFlow | Message;
}

export interface ColumnNameDailyFlow {
  "public data": DataDailyFlow;
}

export interface DataDailyFlow {
  anio_base:     number;
  anio_anterior: number | string;
  fechas:        DateDailyFlow[];
  resumen:       SummaryDailyFlow;
}

export interface DateDailyFlow {
  Dia:                    string;
  Flujo:                  number;
  Flujo_periodo_anterior?: number;
}

export interface SummaryDailyFlow {
  total_flujo:          number;
  total_flujo_anterior: number;
  diferencia:           number;
  porcentaje:           string;
  indicador:            string;
}
